const toPlayMoney = (number) => number.toLocaleString(undefined, { maximumFractionDigits: 0, minimumFractionDigits: 0 });
export default toPlayMoney;
